module.exports = "---\nsummary: List reports and be notified when new report have been generated.\n---\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/reference/content/happyco.inspect.report.v1/overview.md
// module id = 239
// module chunks = 0